import { Component, Input, OnInit } from '@angular/core';

import { Platform } from 'psd-common';

@Component({
  selector: 'central-login-header',
  templateUrl: 'central-login-login-header.component.html'
})
export class CentralLoginLoginHeaderComponent implements OnInit {
  @Input('platform') platform: Platform;
  ngOnInit() {}
}
